import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash';
import React from 'react';

import { H5 } from '@/components/type';
import RichText from '@/components/rich-text';

import { useAccordion } from './hooks';
import { DividerFaq, StyledAccordionDetails, StyledAccordionFaq, StyledAccordionSummaryFaq } from './styles';

import type { HsiycAccordionItem } from '@tac/sanity-client/types';

type AccordionFaqProps = {
  name?: string;
  items?: Partial<HsiycAccordionItem>[];
};

const AccordionFaq = ({ name, items = [] }: AccordionFaqProps) => {
  const [openAccordions, handleChange] = useAccordion();
  const textPadding = { xs: 4.5, sm: 9 };

  return (
    <>
      {_.map(items, (item, accordionId) => {
        return (
          <Box mb={{ xs: 3, sm: 6 }} key={accordionId}>
            <StyledAccordionFaq
              expanded={!!openAccordions[accordionId]}
              onChange={() => handleChange({ accordionIndex: accordionId, accordionName: name, itemName: item.title })}
            >
              <StyledAccordionSummaryFaq expandIcon={<ExpandMoreIcon />}>
                <Box p={textPadding}>
                  <H5 as="h3">{item.title}</H5>
                </Box>
              </StyledAccordionSummaryFaq>
              <DividerFaq />
              <StyledAccordionDetails>
                <Box p={textPadding}>
                  <RichText portableTextValue={item.body} />
                </Box>
              </StyledAccordionDetails>
            </StyledAccordionFaq>
          </Box>
        );
      })}
    </>
  );
};

export default AccordionFaq;
